import {inject, Inject, Injectable, LOCALE_ID, Optional} from '@angular/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {MAT_DATE_FORMATS} from '@angular/material/core';
import * as _moment from 'moment-timezone';
import {TimezoneService} from './timezone.service';

const moment = _moment;

// Define a custom injection token for timezone
export const CUSTOM_TIMEZONE = 'CUSTOM_TIMEZONE';

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {
  private timezone: string;
  private timezoneService = inject(TimezoneService);

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    @Inject(MAT_DATE_FORMATS) dateFormats: object,
    @Optional() @Inject(CUSTOM_TIMEZONE) timezone?: string
  ) {
    super(locale, dateFormats);
    this.timezone = timezone || this.timezoneService.getTimeZone() || moment.tz.guess();
  }

  getFirstDayOfWeek(): number {
    return 1; // Monday as the first day of the week
  }

  // Override methods to use timezone
  today(): _moment.Moment {
    return moment().tz(this.timezone).startOf('day');
  }

  parse(
    value: string | number | Date | _moment.Moment | null | undefined,
    parseFormat: string | string[]
  ): _moment.Moment | null {
    if (value && typeof value === 'string' && value.trim()) {
      return moment.tz(value, parseFormat, this.locale, this.timezone);
    }
    return value ? moment.tz(value, this.timezone) : null;
  }

  format(date: _moment.Moment, displayFormat: string): string {
    return date.clone().tz(this.timezone).format(displayFormat);
  }

  createDate(year: number, month: number, date: number): _moment.Moment {
    return moment.tz([year, month, date], this.timezone);
  }

  // Add method to change timezone dynamically
  setTimezone(timezone: string): void {
    this.timezone = timezone;
  }

  getTimezone(): string {
    return this.timezone;
  }
}
